import Axios from "axios";
var RegionService = (function () {
    function RegionService() {
    }
    RegionService.prototype.getLicenseList = function (params) {
        return Axios.get("supplierclientapi/document/list", { params: params });
    };
    RegionService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/document/info", { params: params });
    };
    RegionService.prototype.getLicenseOrderList = function (params) {
        return Axios.post("supplierclientapi/document/order_list", params);
    };
    RegionService.prototype.licenseOrderAdd = function (params) {
        return Axios.post("supplierclientapi/document/order_create", params);
    };
    RegionService.prototype.licenseOrderDelete = function (params) {
        return Axios.post("supplierclientapi/document/order_delete", params);
    };
    RegionService.prototype.licenseAddSave = function (params) {
        return Axios.post("supplierclientapi/document/create", params);
    };
    RegionService.prototype.editLicense = function (params) {
        return Axios.post("supplierclientapi/document/update", params);
    };
    RegionService.prototype.delete = function (params) {
        return Axios.get("supplierclientapi/document/delete", { params: params });
    };
    RegionService.prototype.licenseEdit = function (params) {
        return Axios.post("api/areadelete", params);
    };
    RegionService.prototype.getWarnDays = function () {
        return Axios.get("supplierclientapi/document/warningday");
    };
    RegionService.prototype.getCompanyInfo = function () {
        return Axios.get("supplierclientapi/companyinfo/info");
    };
    RegionService.prototype.getDocumentTypeList = function (params) {
        return Axios.get("supplierclientapi/document_type/list", { params: params });
    };
    RegionService.prototype.multiModifyClaimType = function (params) {
        return Axios.post("supplierclientapi/document_type/modify_claim_type", params);
    };
    RegionService.prototype.getDocumentAlreadyBindGoods = function (params) {
        return Axios.get("supplierclientapi/document/goods_list", { params: params });
    };
    RegionService.prototype.documentBindGoods = function (params) {
        return Axios.post("supplierclientapi/document/bind_goods", params);
    };
    RegionService.prototype.documentBindGoodsFormat = function (params) {
        return Axios.post("supplierclientapi/document/bind_goods_format", params);
    };
    RegionService.prototype.getDocumentAlreadyBindBusiness = function (params) {
        return Axios.get("supplierclientapi/document/business_list", { params: params });
    };
    RegionService.prototype.documentBindBusiness = function (params) {
        return Axios.post("supplierclientapi/document/bind_business", params);
    };
    RegionService.prototype.documentUnBindGoods = function (params) {
        return Axios.post("supplierclientapi/document/unbind_goods", params);
    };
    RegionService.prototype.documentUnBindGoodsFormat = function (params) {
        return Axios.post("supplierclientapi/document/unbind_goods_format", params);
    };
    RegionService.prototype.documentUnBindBusiness = function (params) {
        return Axios.post("supplierclientapi/document/unbind_business", params);
    };
    RegionService.prototype.documentManualSync = function (params) {
        return Axios.post("supplierclientapi/document/manual_sync", params);
    };
    RegionService.createInstance = function () {
        RegionService.getInstance();
    };
    RegionService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return RegionService;
}());
export default RegionService;
